import script from "./ProgressReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressReport.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__